import socketIOClient from "socket.io-client";

const socketIOUrl = process.env.REACT_APP_SOCKET_URL;
const socketIoObject = socketIOClient(socketIOUrl, {
  path: "/api/chat",
});

export default socketIoObject;
